import query from './query';
import axios from 'axios';

class ProductGroup {
  
  private productGroup:HTMLElement;
  
  constructor() {
    this.productGroup = null;
  }

  init() {
    this.productGroup = document.querySelector('[data-product-group]');
  }

  async getJSON() {
    const id = this.productGroup.dataset.productGroup;
    let response:any = null;

    const url = query.buildURL({
      type: 'product',
      operator: 'OR',
      view: 'json',
      tags: [
        {
          key: 'group',
          value: id
        }
      ]
    });

    try {
      response = await axios({
        method: 'get',
        url: url,
        responseType: 'document'
      });
      response = JSON.parse(response.data.body.innerText);
    }
    catch(error) {
      console.error(error);
    }
    
    return new Promise((resolve, reject) => {
      resolve(response);
    })
  }
}

export default new ProductGroup();